import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { ClosedPeriodListLoad, ClosedPeriodListInitialState } from './closed-period-list.actions';
import { LIST_SERVER_PAGINATION_INITIAL_STATE, ListServerPaginationStateModel } from '../../../../../../common/models';
import { catchError, map, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../../common/services/notification/notification.service';
import { ClosedPeriodListService } from './closed-period-list.service';
import { ClosedPeriodModel } from '../models';
import { CustomHttpErrorResponse, Error } from '../../../../../../common/constants/error';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface ClosedPeriodListStateModel {
  page: ListServerPaginationStateModel<ClosedPeriodModel>;
  timezone: string;
}

const initialState: ClosedPeriodListStateModel = {
  page: LIST_SERVER_PAGINATION_INITIAL_STATE,
  timezone: null,
};

@State<ClosedPeriodListStateModel>({
  name: 'closedPeriodList',
  defaults: initialState,
})
@Injectable()
export class ClosedPeriodListState {
  constructor(
    private closedPeriodListService: ClosedPeriodListService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getClosedPeriods(state: ClosedPeriodListStateModel): ListServerPaginationStateModel<ClosedPeriodModel> {
    return state.page;
  }

  @Selector()
  static getLoaded(state: ClosedPeriodListStateModel): boolean {
    return state.page.loaded;
  }

  @Selector()
  static getTimezone(state: ClosedPeriodListStateModel): string {
    return state.timezone;
  }

  @Action(ClosedPeriodListLoad)
  getClosedPeriods(
    ctx: StateContext<ClosedPeriodListStateModel>,
    { payload }: ClosedPeriodListLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.closedPeriodListService.getClosedPeriodList(payload).pipe(
      take(1),
      map((data: ClosedPeriodListStateModel) => {
        ctx.patchState({
          page: { ...data.page, loaded: true },
          timezone: data.timezone,
        });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ClosedPeriodListInitialState)
  setInitialState(ctx: StateContext<ClosedPeriodListStateModel>): void {
    ctx.setState(initialState);
  }
}
